<div class="p-4">
    <div class="d-flex justify-content-between">
        <div class="card-sub-heading my-3 font_custom">Rx Details</div>
        <button mat-icon-button (click)="this.dialogRef.close()" type="button">
            <img src="assets/images/icons/grey_cross_icon.png" alt="close icon" />
        </button>
    </div>

    <div class="w-100 h-100 d-flex align-items-center justify-content-center loader" *ngIf="progress_spinner">
        <span class="purpleLoader"></span>
    </div>

    <ng-container *ngIf="!progress_spinner">
        <div class="pagination-table mt-3" *ngIf="drugListFound && drugList.length > 0; else noData">
            <table class="table height" aria-describedby="Report Parameters Table">
                <thead>
                    <tr>
                        <th>RX ID</th>
                        <th>Quantity</th>
                        <th>Drug Name</th>
                        <th>DIN</th>
                        <th>Last Fill Date</th>
                    </tr>
                </thead>
                <tbody>
                    <tr *ngFor="let item of drugList">
                        <td>{{ item?.added_rx_num != null && item?.added_rx_num !== '' ? item.added_rx_num : 'N/A' }}</td>
                        <td>
                            <ng-container *ngIf="item?.dispQty != null && item?.remQty != null && item.dispQty < item.remQty; else showDispQty">
                                {{ item?.remQty != null ? (item.dispQty | number:'1.0-0') : 'N/A' }}
                            </ng-container>
                            <ng-template #showDispQty>
                                {{ item?.dispQty != null && item?.remQty != null ? (item.remQty | number:'1.0-0') : 'N/A' }}
                            </ng-template>
                        </td>
                        <td class="text-wrap">
                            {{ item?.drgName != null && item?.drgName !== '' ? item.drgName : 'N/A' }}
                            <div *ngIf="item?.reasonText">
                                <span style="color: #E3432B;">Reason:</span> {{ item.reasonText }}
                            </div>
                        </td>
                        <td>{{ item?.din != null && item?.din !== '' ? item.din : 'N/A' }}</td>
                        <td>{{ item?.lastFillDate ? helperService.getSlashDate(item.lastFillDate) : 'N/A' }}</td>
                    </tr>
                </tbody>
            </table>
        </div>
    </ng-container>
    <ng-template #noData>
        <div class="d-flex flex-column align-items-center w-100 mt-3 justify-content-center noDataFound">
            <img src="assets/images/emptystate.png" class="mb-3" alt="no data found icon" />
            <div class="semibold mb-1">No Data Found</div>
            <div>Data has not been found</div>
        </div>
    </ng-template>
</div>